import anchors from './anchors';
import drawer from './drawer';

const initialize = () => {
    anchors.initialize();
    drawer.initialize();
};

export default {
    initialize,
};

